import _ from 'lodash';
import * as util from '#packages/util';
import { editorStateSel } from './rootSelectors';
import { createSelector } from './selector';

import * as selection from '../selection/selection';
import * as attachCandidate from '../attachCandidate/attachCandidate';
import type { StateMapperArgs } from 'types/redux';
import type { CompRef } from '@wix/document-services-types';

const { getSelectedCompsRefs } = selection.selectors;
const { selectAttachCandidateComponent } = attachCandidate.selectors;

export const selectedCompsSel = createSelector(
  [editorStateSel],
  getSelectedCompsRefs,
);

export const singleSelectedCompSel = createSelector<
  StateMapperArgs,
  CompRef[],
  CompRef
>([selectedCompsSel], _.head);

export const attachCandidateSel = createSelector(
  [editorStateSel],
  selectAttachCandidateComponent,
);

export const isMultiselectSel = createSelector(
  [selectedCompsSel],
  util.array.isMultiselect,
);
